/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sync_Last_Sync_Days_AgoInputs */



/**
* | output |
* | --- |
* | "{count}d ago" |
*
* @param {Sync_Last_Sync_Days_AgoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_last_sync_days_ago = /** @type {((inputs: Sync_Last_Sync_Days_AgoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Last_Sync_Days_AgoInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vor ${i?.count} T.`)
	return /** @type {LocalizedString} */ (`${i?.count}d ago`)
});